var _path, _circle, _circle2, _circle3, _path2, _circle4, _circle5, _circle6, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 80 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 36") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67,52H46a2,2,0,0,0,0,4H67a2.0027,2.0027,0,0,1,2,2v8a2.0027,2.0027,0,0,1-2,2H13a2.0027,2.0027,0,0,1-2-2V58a2.0027,2.0027,0,0,1,2-2H34a2,2,0,0,0,0-4H13a6.0066,6.0066,0,0,0-6,6v8a6.0066,6.0066,0,0,0,6,6H67a6.0066,6.0066,0,0,0,6-6V58A6.0066,6.0066,0,0,0,67,52Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63,
    cy: 62,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 62,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 62,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17,48H34a2,2,0,0,0,0-4H17a2.0027,2.0027,0,0,1-2-2V22H65V42a2.0027,2.0027,0,0,1-2,2H46a2,2,0,0,0,0,4H63a6.0066,6.0066,0,0,0,6-6V14a6.0066,6.0066,0,0,0-6-6H17a6.0066,6.0066,0,0,0-6,6V42A6.0066,6.0066,0,0,0,17,48Zm0-36H63a2.0027,2.0027,0,0,1,2,2v4H15V14A2.0027,2.0027,0,0,1,17,12Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 15,
    r: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 15,
    r: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 15,
    r: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5859,41.4141a2,2,0,0,0,2.8282-2.8282l-4-4a2,2,0,0,0-2.8282,0l-4,4a2,2,0,0,0,2.8282,2.8282L38,40.8281V59.1719l-.5859-.586a2,2,0,0,0-2.8282,2.8282l4,4a1.9995,1.9995,0,0,0,2.8282,0l4-4a2,2,0,0,0-2.8282-2.8282L42,59.1719V40.8281Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsocket);
export default __webpack_public_path__ + "static/media/websocket.8718543b563d3a0e06e41ad004bf79cd.svg";
export { ForwardRef as ReactComponent };